import api from "utils/api";
import { floorPlanLayoutKeys } from "../useFloorPlanLayout";
import type { LayoutDetectionStatus, PollLayoutDetection } from "./types";

export const layoutDetectionKeys = {
  all: ["quantitySurveyorFloorPlanLayoutDetection"] as const,
  detail: (floorPlanId: number | undefined) =>
    [...layoutDetectionKeys.all, floorPlanId] as const,
};

export const pollLayoutDetection: PollLayoutDetection = async ({
  client,
  floorPlanId,
  onRunFailed,
}) => {
  const status: LayoutDetectionStatus =
    await api.getQuantitySurveyorFloorPlanLayoutDetectionStatus(floorPlanId);
  const previous = client.getQueryData<LayoutDetectionStatus>(
    layoutDetectionKeys.detail(floorPlanId),
  );
  // This very request may have uploaded the result after the rooms were loaded.
  if (status.state === "done" && previous?.state !== "done") {
    client.invalidateQueries({
      queryKey: floorPlanLayoutKeys.detail(floorPlanId),
    });
  }
  if (status.state === "failed" && previous?.state === "running") {
    onRunFailed();
  }
  return status;
};
